var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2554 11.9423C17.8998 11.4932 18.0015 11.2933 18.2554 10.8918C18.26 10.8873 21.1961 6.83009 21.4986 5.45418L21.5004 5.45326C21.6508 4.95184 21.5004 4.58334 20.7735 4.58334H18.3682C17.7558 4.58334 17.4735 4.89959 17.3223 5.25343C17.3223 5.25343 16.0976 8.18493 14.3651 10.0852C13.8059 10.6343 13.5474 10.8103 13.2422 10.8103C13.0918 10.8103 12.8581 10.6343 12.8581 10.1328V5.45326C12.8581 4.85193 12.6867 4.58334 12.1798 4.58334H8.39758C8.0135 4.58334 7.78525 4.86384 7.78525 5.12509C7.78525 5.69526 8.6515 5.82634 8.74133 7.43051V10.9111C8.74133 11.6738 8.60292 11.814 8.29583 11.814C7.47817 11.814 5.49358 8.87059 4.3175 5.50184C4.08008 4.84826 3.84817 4.58426 3.23125 4.58426H0.825C0.138417 4.58426 0 4.90051 0 5.25434C0 5.87951 0.817666 8.98793 3.80233 13.0946C5.7915 15.8978 8.59283 17.4167 11.1412 17.4167C12.6729 17.4167 12.8599 17.0793 12.8599 16.4991C12.8599 13.8206 12.7215 13.5676 13.4888 13.5676C13.8444 13.5676 14.4568 13.7436 15.8868 15.0957C17.5212 16.6989 17.7898 17.4167 18.7046 17.4167H21.1099C21.7956 17.4167 22.143 17.0793 21.9432 16.4138C21.4858 15.0141 18.3948 12.1348 18.2554 11.9423Z",
    fill: "#4B729F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.c6d797c390303fd904cfdaf113fdf527.svg";
export { ForwardRef as ReactComponent };